// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2LPuN","name":"Header_name__3yyUA","birthday":"Header_birthday__7Vlg_","skeleton":"Header_skeleton__1dklv"};